<template>
  <div class="age-ei-profile-comparison-block">
    <a-card
        :bordered="true"
        class="age-ei-profile-comparison-block__card"
    >
      <div class="age-ei-profile-comparison-block__header">
        <h3 class="age-ei-profile-comparison-block__title">
          {{ averageTitle }}
        </h3>
      </div>

      <EiScaleComparisonTable
          :sections="averageProfileSections"
          :show-scale-after-each-section="true"
          :show-first-section-title="false"
          :row-gap="12"
          :track-height="12"
          :bar-gap="2"
      />
    </a-card>

    <a-card
        :bordered="true"
        class="age-ei-profile-comparison-block__card"
    >
      <div class="age-ei-profile-comparison-block__header">
        <h3 class="age-ei-profile-comparison-block__title">
          {{ detailsTitle }}
        </h3>
      </div>

      <EiScaleComparisonTable
          :sections="detailsSections"
          :show-scale-after-each-section="false"
          :show-first-section-title="true"
          :row-gap="12"
          :track-height="12"
          :bar-gap="2"
      />
    </a-card>
  </div>
</template>

<script>


import EiScaleComparisonTable from "@/views/Report/ManagementPotentialReport/EiScaleComparisonTable.vue";

export default {
  name: 'AgeEiProfileComparisonBlock',

  components: {
    EiScaleComparisonTable

  },

  props: {
    averageTitle: {
      type: String,
      default: 'Средний ЭИ-профиль',
    },

    detailsTitle: {
      type: String,
      default: 'Детализация ЭИ (10 разделов способностей)',
    },

    averageProfileSections: {
      type: Array,
      default: () => [],
    },

    detailsSections: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
.age-ei-profile-comparison-block {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

.age-ei-profile-comparison-block__card {
  min-width: 0;
  border-radius: 8px;
}

.age-ei-profile-comparison-block__header {
  margin-bottom: 20px;
}

.age-ei-profile-comparison-block__title {
  margin: 0;
  min-width: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.85);
}

@media (max-width: $tablet-breakpoint) {
  .age-ei-profile-comparison-block {
    grid-template-columns: 1fr;
  }
}

@media (max-width: $mobile-breakpoint) {
  .age-ei-profile-comparison-block__card :deep(.ant-card-body) {
    padding: 14px 12px;
  }

  .age-ei-profile-comparison-block__title {
    font-size: 15px;
  }
}
</style>